import { loadStripe, Stripe } from "@stripe/stripe-js";

const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

// Stripe.js is fetched from js.stripe.com at runtime. If that script can't load
// (e.g. headless/sandboxed env, network block, or a missing public key), the
// rejection must NOT bubble up unhandled — an unhandled rejection triggers CRA's
// app-wide "Uncaught runtime errors" overlay on every page. Resolve to null
// instead: <Elements stripe={null}> is valid (it renders until Stripe is ready),
// so payment features degrade gracefully rather than crash-overlaying the app.
export const stripePromise: Promise<Stripe | null> = stripePublicKey
  ? loadStripe(stripePublicKey).catch((e) => {
      console.warn("Stripe.js failed to load; payment features disabled", e);
      return null;
    })
  : Promise.resolve(null);
